import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["moldSelect", "moldVariantSelect", "wickRecommendation", "wickTypeSelect", "wickVariantSelect"]
  static values = {
    molds: Array,
    moldVariants: Array,
    wicks: Array,
    wickVariants: Array
  }

  connect() {
    // If there's a selected mold, populate mold variants
    if (this.hasMoldSelectTarget && this.moldSelectTarget.value) {
      this.populateMoldVariants(parseInt(this.moldSelectTarget.value))
    }

    // If there's a selected mold variant, enable the variant select
    if (this.hasMoldVariantSelectTarget && this.moldVariantSelectTarget.value) {
      this.moldVariantSelectTarget.disabled = false
      this.showWickRecommendation()
    }

    // If there's a selected wick type, populate wick variants
    if (this.hasWickTypeSelectTarget && this.wickTypeSelectTarget.value) {
      this.populateWickVariants(parseInt(this.wickTypeSelectTarget.value))
    }
  }

  updateMoldVariants(event) {
    const moldId = parseInt(event.target.value)
    this.populateMoldVariants(moldId)
    // Hide wick recommendation when changing mold
    this.hideWickRecommendation()
  }

  populateMoldVariants(moldId) {
    if (!this.hasMoldVariantSelectTarget) return

    const moldVariantSelect = this.moldVariantSelectTarget
    const currentValue = moldVariantSelect.value

    // Clear current options
    moldVariantSelect.innerHTML = '<option value="">Select a variant</option>'

    if (!moldId) {
      moldVariantSelect.disabled = true
      return
    }

    // Filter variants for selected mold
    const variants = this.moldVariantsValue.filter(v => v.mold_id === moldId)

    // Add variant options
    variants.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name
      // Restore the previously selected value if it exists
      if (variant.id.toString() === currentValue) {
        option.selected = true
      }
      moldVariantSelect.appendChild(option)
    })

    // Enable the select
    moldVariantSelect.disabled = false
  }

  variantSelected(event) {
    if (this.hasWickRecommendationTarget) {
      this.showWickRecommendation()
    }
    this.selectRecommendedWick()
  }

  updateWickVariants(event) {
    const wickId = parseInt(event.target.value)
    this.populateWickVariants(wickId)
  }

  populateWickVariants(wickId) {
    if (!this.hasWickVariantSelectTarget) return

    const wickVariantSelect = this.wickVariantSelectTarget
    const currentValue = wickVariantSelect.value

    // Clear current options
    wickVariantSelect.innerHTML = '<option value="">Select a wick type first</option>'

    if (!wickId) {
      wickVariantSelect.disabled = true
      return
    }

    // Filter wick variants for selected wick
    const variants = this.wickVariantsValue.filter(wv => wv.wick_id === wickId)

    // Add variant options
    variants.forEach(variant => {
      const option = document.createElement('option')
      option.value = variant.id
      option.textContent = variant.display_name_with_stock
      // Restore the previously selected value if it exists
      if (variant.id.toString() === currentValue) {
        option.selected = true
      }
      wickVariantSelect.appendChild(option)
    })

    // Enable the select
    wickVariantSelect.disabled = false
  }

  selectRecommendedWick() {
    if (!this.hasMoldVariantSelectTarget) return

    const variantId = parseInt(this.moldVariantSelectTarget.value)
    if (!variantId) {
      return
    }

    const variant = this.moldVariantsValue.find(v => v.id === variantId)
    if (variant && variant.recommended_wick_variant_id && this.hasWickTypeSelectTarget && this.hasWickVariantSelectTarget) {
      // Find the wick type for the recommended wick variant
      const recommendedWickVariant = this.wickVariantsValue.find(wv => wv.id === variant.recommended_wick_variant_id)

      if (recommendedWickVariant) {
        // Only auto-select if no wick is currently selected
        if (!this.wickTypeSelectTarget.value || this.wickTypeSelectTarget.value === '') {
          // Select the wick type
          this.wickTypeSelectTarget.value = recommendedWickVariant.wick_id
          // Populate and select the wick variant
          this.populateWickVariants(recommendedWickVariant.wick_id)
          this.wickVariantSelectTarget.value = variant.recommended_wick_variant_id
        }
      }
    }
  }

  showWickRecommendation() {
    if (!this.hasMoldVariantSelectTarget || !this.hasWickRecommendationTarget) return

    const variantId = parseInt(this.moldVariantSelectTarget.value)
    if (!variantId) {
      this.hideWickRecommendation()
      return
    }

    const variant = this.moldVariantsValue.find(v => v.id === variantId)
    if (variant && variant.recommended_wick_variant_id && variant.recommended_wick_variant_name) {
      this.wickRecommendationTarget.innerHTML = `
        <div class="alert alert-info">
          <strong>Recommended Wick:</strong> ${variant.recommended_wick_variant_name}
        </div>
      `
      this.wickRecommendationTarget.style.display = ''
    } else {
      this.hideWickRecommendation()
    }
  }

  hideWickRecommendation() {
    if (this.hasWickRecommendationTarget) {
      this.wickRecommendationTarget.style.display = 'none'
    }
  }

  togglePerfumeFields(event) {
    const perfumeFields = document.getElementById('perfume-fields')
    if (event.target.value && event.target.value !== '') {
      perfumeFields.style.display = ''
    } else {
      perfumeFields.style.display = 'none'
    }
  }
}

